import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=08aeaec0&"
import script from "./AlertView.vue?vue&type=script&lang=js&"
export * from "./AlertView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports